import { EntityTypes, type IEntityTypeIdentifier } from "./basic.models";
import type { BaseValidationResponse } from "./validations.models";

export interface AttachmentFile extends File{
    attachmentTypeId: number;
    internalName: string;
}

export class EntityAttachmentModel implements IEntityTypeIdentifier {
    identifier: string;
    entityAttachmentId?: number;
    path?: string;
    name?: string;
    physicalDocumentReceived?: boolean;
    expiryDate?: string;
    gdprExpiryDate?: string;
    expiredDocumentUpdatedDate?: string;
    documentReceivedOnDate?: Date;
    entityId?: number;
    attachmentTypeId?: number;
    entityTypeId?: number;
    attachmentType?: AttachmentTypeModel;
    attachmentTags?: AttachmentTagModel[];
    entityType?: EntityTypes = EntityTypes.Attachments;
    metaJson: string;
    systemNotes: string;
    createdDate?: string;
}

export interface AttachmentTypeModel {
    attachmentTypeId: number;
    name: string;
    guid: string;
    internalName: string;
    entityTypeId: number;
}

export interface AttachmentTagModel {
    tag: string;
}

export interface AddEntityAttachmentsResponse extends BaseValidationResponse {
    entityAttachmentsUpdated: EntityAttachmentModel[];
}

export interface GetEntityAttachmentsRequest {
    id?: number;
    entityType?: EntityTypes;
    entityId?: number;
    skipAttachmentTypes?: number[];
}

export interface GetEntityAttachmentsResponse {
    entityAttachments: EntityAttachmentModel[];
}

export interface RightshipEntityAttachmentModel extends IEntityTypeIdentifier {
    entityAttachmentId: number;
    entityId: number;
    attachmentTypeId: number;
    attachmentTypeGuid: string;
    name: string;
    attachmentType: string;
    path: string;
    createdDate: string;
    createdBy: number;
    createdByUserName: string;
    isScanned: boolean;
    hasViruses: boolean;
    systemNotes: string;
}

export interface RemoveEntityAttachmentsResponse {
    attachmentIds: number[];
}

export interface AttachmentDialogModel {
    uri: string,
    name: string,
    path?: string,
    entityAttachmentId?: number,
    onDialogDeleted?: () => Promise<void>
}

export interface AddEntityAttachmentsResponse extends BaseValidationResponse {
    entityAttachmentsUpdated: EntityAttachmentModel[];
}

export interface AddEntityAttachmentsRequest {
    file?: File;
    name: string;
    entityType: EntityTypes;
    entityIds: number[];
    attachmentTypeId?: number;
}

export interface RemoveCorrespondenceAttachmentsRequest {
    entityAttachmentIds: number[];
    correspondenceGuid: string;
}

export interface RemoveEntityAttachmentsResponse {
    attachmentIds: number[];
}

export interface DialogAttachmentsModel {
    entityId:number,
    entityType:number,
    subtaskCorrespondenceId?: number,
    reload: () => Promise<void>,
    onSave: () => Promise<number>,
    afterSaved: (saveResponse: any) => Promise<void>
    currentAttachments?: AttachmentDialogModel[]
}

export interface GetEntityAttachmentsRequest {
    id?: number;
    entityType?: EntityTypes;
    entityId?: number;
    skipAttachmentTypes?: number[];
}

export interface GetEntityAttachmentsResponse {
    entityAttachments: EntityAttachmentModel[];
}

export interface AttachmentViewerDocument {
    thumbnailFileName: string;
    fileName: string;
    pageNumber: number;
    src?: string;
    sasUrl?: string;
    attachmentType?: AttachmentType;
    originalAttachmentName?: string;
    id?: string;
}

export interface AttachmentViewerExecutionModel {
    getAttachmentDocuments?: () => Promise<AttachmentViewerDocument[]>
    newTabIdentifier?: string;
    title?: string;
    count?: number;
    selectedThumbnailId?: string;
}

export enum AttachmentType {
    Image = 'Image',
    Object = 'Object'
}

export enum AttachmentDrawerSection {
    AllAttachment = 'All Attachment',
    CloseOutDocuments = 'Close Out Documents',
    CausationTree = 'Causation Tree'
}

export interface AttachmentViewerNewTab {
    documents: AttachmentViewerDocument[];
}